// Standard HTML and structured ESP payloads stay gated on server support.
export const SERVER_ACCEPTS = { standard: false, esps: false };

// null/undefined means the one page-level request has not completed yet.
export function profilesView(resultOrError, clientSlug) {
  if (resultOrError == null) return { state: 'loading', ready: [], degraded: [] };
  if (resultOrError.status === 404) return { state: 'unavailable', ready: [], degraded: [] };
  if (resultOrError instanceof Error || resultOrError.kind || resultOrError.status >= 400
    || !Array.isArray(resultOrError.profiles)) return { state: 'error', ready: [], degraded: [] };

  const activated = profile => Date.parse(profile.activated_at) || 0;
  const ready = resultOrError.profiles
    .filter(profile => clientSlug && profile?.scope?.client_id === clientSlug)
    .map(profile => ({ ...profile, region_policies: Array.isArray(profile.region_policies) ? [...profile.region_policies] : [] }))
    .sort((a, b) => activated(b) - activated(a));
  // Degraded registry rows have only profile_id/code, so cannot be client-filtered.
  const degraded = Array.isArray(resultOrError.degraded_profiles) ? [...resultOrError.degraded_profiles] : [];
  return { state: ready.length ? 'ready' : 'none', ready, degraded };
}

const LAYOUT_CLIENTS = ['apple', 'gmail', 'outlook'];
const clampWidth = (value, min, max, fallback) =>
  Math.min(max, Math.max(min, Math.round(Number.isFinite(value) ? value : fallback)));

export function clampLayout(l) {
  const layout = l || {};
  const desktop = clampWidth(layout.desktop, 480, 800, 600);
  const mobile = Math.min(desktop, clampWidth(layout.mobile, 320, 480, 375));
  const clients = Array.isArray(layout.clients) ? layout.clients : LAYOUT_CLIENTS;
  return {
    mode: ['responsive', 'scalable', 'fixed'].includes(layout.mode) ? layout.mode : 'responsive',
    desktop, mobile, clients: LAYOUT_CLIENTS.filter(client => clients.includes(client)),
  };
}

// Takes the page's state names, plus the resolved agentObj.engine as engine,
// and standard/layout for the new scope. Validation remains with the caller.
export function startPayload(state) {
  const { source, buildName, client, autoDetect, engine, tier, esp, espSummary, espDetail, preset,
    afterburnerOn, instr, variantProfileId, figmaUrl, uploadId, standard, layout } = state;
  if (standard && !SERVER_ACCEPTS.standard) return { blocked: 'standard_unsupported' };
  const payload = {
    source, test_id: (buildName || '').trim(), client_slug: engine === 'sabre' ? client : (autoDetect ? null : client), autoDetect,
    engine, tier: engine === 'router' ? tier : null,
    esp, preset, afterburner: afterburnerOn, instructions: instr,
  };
  if (SERVER_ACCEPTS.esps && espDetail) {
    payload.esp = espSummary;
    payload.esps = espDetail.list;
    payload.espNotes = espDetail.notes;
  }
  if (standard) {
    payload.client_slug = null;
    payload.autoDetect = false;
    payload.preset = 'standard';
    payload.standard = true;
    payload.layout = clampLayout(layout);
  } else if (engine === 'sabre' && variantProfileId) {
    payload.variant_profile_id = variantProfileId;
  }
  if (source === 'figma') {
    payload.figma_url = (figmaUrl || '').trim();
  } else if (uploadId) {
    payload.upload_id = uploadId;
  }
  return payload;
}

if (typeof window !== 'undefined') {
  window.GooseNewBuild = { SERVER_ACCEPTS, startPayload, clampLayout, profilesView };
}
